<p-dialog
  #fastPropVeic
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">
        Adicionar proprietário de veículo
      </span>
      <i class="mdi mdi-car-key ml-2 text-primary"></i>
    </div>
  </ng-template>
  <mat-tab-group>
    <mat-tab label="Dados" style="flex: 1;">
      <ng-template mat-tab-label>
        Dados
        <i
          *ngIf="formDadosValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>
      <div class="row m-0 pt-1">
        <p-inputGroup class="col-md-12 mt-3">
          <div class="width-100">
            <span class="p-float-label">
              <input
                #cpfCnpjInput
                (click)="cpfCnpjInput.select()"
                type="text"
                id="inputtext-right"
                pInputText
                [formControl]="form.get('cpf_cnpj')"
                [mask]="cpfCnpjMask"
                (animationend)="removeValidatorMask()"
                (blur)="checkCpfCnpj()"
                class="input-filters"
              />
              <p-inputGroupAddon
                [ngClass]="{
                  'p-inputgroup-addon-right': true,
                  'cursor-pointer':
                    !loadingParceiro &&
                    form.get('cpf_cnpj').value &&
                    (form.get('cpf_cnpj').valid ||
                      form.get('cpf_cnpj').disabled)
                }"
                (click)="
                  !loadingParceiro &&
                  form.get('cpf_cnpj').value &&
                  (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
                    ? openDialogConsultaPredictus()
                    : null
                "
                [pTooltip]="
                  !loadingParceiro &&
                  form.get('cpf_cnpj').value &&
                  (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
                    ? 'Consultar dados'
                    : ''
                "
              >
                <i
                  [class]="
                    !form.get('cpf_cnpj').value || form.get('cpf_cnpj').invalid
                      ? 'pi pi-fw pi-search text-gray'
                      : loadingParceiro
                      ? 'pi pi-fw pi-spin cursor-pointer pi-spinner text-primary'
                      : 'pi pi-fw pi-search cursor-pointer text-primary'
                  "
                ></i>
              </p-inputGroupAddon>
              <label for="inputtext-right">CPF/CNPJ</label>
            </span>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              {{ messages.cpf_cnpj.repeated }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              {{ messages.cpf_cnpj.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              {{ messages.cpf_cnpj.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              {{ messages.cpf_cnpj.duplicate }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj.validateCNPJ }}
            </small>
          </div>
        </p-inputGroup>
        <div class="flex-column col-md-12 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Nome/razão social</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('nome_razao_social')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('required')
            "
          >
            {{ messages.nome_razao_social.required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('maxlength')
            "
          >
            {{ messages.nome_razao_social.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>
        <div class="flex-column col-md-12 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Apelido/nome fantasia</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('apelido_nome_fantasia')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('maxlength')
            "
          >
            {{ messages.apelido_nome_fantasia.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>

        <div class="flex-column col-md-4 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>RNTRC</mat-label>
            <input
              matInput
              type="text"
              (keydown)="notText($event)"
              [formControl]="form.get('rntrc')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('rntrc').touched &&
              form.get('rntrc').hasError('maxlength')
            "
          >
            {{ messages.rntrc.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('rntrc').hasError('isEmptyValue')"
          >
            {{ messages.rntrc.isEmptyValue }}
          </small>
        </div>
        <div class="flex-column col-md-4 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>TAF</mat-label>
            <input
              matInput
              type="text"
              (keydown)="notText($event)"
              [formControl]="form.get('taf')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('taf').touched && form.get('taf').hasError('maxlength')
            "
          >
            {{ messages.taf.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('taf').hasError('isEmptyValue')"
          >
            {{ messages.taf.isEmptyValue }}
          </small>
        </div>
        <div class="col-md-4 mt-3">
          <mat-form-field appearance="outline" class="width-100">
            <mat-label>TAC</mat-label>
            <mat-select [formControl]="form.get('tipo_tac')">
              <mat-option *ngFor="let i of tipoTAC" [value]="i.value">
                {{ i.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-column col-md-6 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Inscrição estadual/RG</mat-label>
            <input
              matInput
              type="text"
              (keydown)="notText($event)"
              (blur)="checkRgInscEstadual()"
              [formControl]="form.get('rg_insc_est')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('rg_insc_est').touched &&
              form.get('rg_insc_est').hasError('pattern')
            "
          >
            {{ messages.rg_insc_est.pattern }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('rg_insc_est').touched &&
              form.get('rg_insc_est').hasError('maxlength')
            "
          >
            {{ messages.rg_insc_est.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
          >
            {{ messages.rg_insc_est.existSpecialChar }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
          >
            {{ messages.rg_insc_est.isEmptyValue }}
          </small>
        </div>
        <div class="flex-column col-md-6 mt-3">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Registro estadual</mat-label>
            <input
              matInput
              type="text"
              (keydown)="notText($event)"
              [formControl]="form.get('registro_estadual')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('registro_estadual').touched &&
              form.get('registro_estadual').hasError('maxlength')
            "
          >
            {{ messages.registro_estadual.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('registro_estadual').hasError('existSpecialChar')"
          >
            {{ messages.registro_estadual.existSpecialChar }}
          </small>
          <small
            class="p-error"
            *ngIf="form.get('registro_estadual').hasError('isEmptyValue')"
          >
            {{ messages.registro_estadual.isEmptyValue }}
          </small>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Endereço" style="flex: 1;">
      <ng-template mat-tab-label>
        Endereço
        <i
          *ngIf="formAddressValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>
      <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
    </mat-tab>
    <mat-tab label="Contatos">
      <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
    </mat-tab>
  </mat-tab-group>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!formValid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
